import { useTranslation } from 'react-i18next';
import StatusBadge from './StatusBadge';
import PriorityDot from './PriorityDot';

const Table = ({ filtered, history, S, canCreateClaim, userRole }) => {
  const { t } = useTranslation();
  const headers = [
    t('screens.claimsScreen.colClaimNumber'),
    t('screens.claimsScreen.colClaimant'),
    t('screens.claimsScreen.colLineOfBusiness'),
    t('screens.claimsScreen.colDateOfLoss'),
    t('screens.claimsScreen.colReserve'),
    t('screens.claimsScreen.colStatus'),
    t('screens.claimsScreen.colPriority'),
    t('screens.claimsScreen.colAssignedTo'),
    t('screens.claimsScreen.colUpdated'),
  ];
  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '0 32px' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: `2px solid ${S.borderLight}` }}>
            {headers.map(h => (
              <th
                key={h}
                style={{
                  backgroundColor: 'rgb(248, 250, 252)',
                  padding: '14px 12px',
                  textAlign: 'left',
                  fontSize: 11,
                  fontWeight: 700,
                  color: S.textMuted,
                  textTransform: 'uppercase',
                  letterSpacing: 0.8,
                }}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filtered.map((c, i) => (
            <tr
              key={c.id}
              onClick={() => history.push(`/claims/${c._id || c.id}`)}
              style={{ borderBottom: `1px solid ${S.borderLight}`, cursor: 'pointer', background: i % 2 === 0 ? '#fff' : S.bgCard, transition: 'background 0.15s' }}
              onMouseEnter={e => (e.currentTarget.style.background = S.bgHover)}
              onMouseLeave={e => (e.currentTarget.style.background = i % 2 === 0 ? '#fff' : S.bgCard)}
            >
              <td style={{ padding: '14px 12px', fontSize: 13, fontWeight: 600, color: S.burgundy }}>{c.id}</td>
              <td style={{ padding: '14px 12px' }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{c.claimant}</div>
                <div style={{ fontSize: 12, color: S.textMuted }}>{c.company}</div>
              </td>
              <td style={{ padding: '14px 12px', fontSize: 13, color: S.textSecondary }}>{c.lob}</td>
              <td style={{ padding: '14px 12px', fontSize: 13, color: S.textSecondary, whiteSpace: 'nowrap' }}>{c.lossDate}</td>
              <td style={{ padding: '14px 12px', fontSize: 13, color: S.textSecondary, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{c.reserve}</td>
              <td style={{ padding: '14px 12px' }}>
                <StatusBadge status={c.status} />
              </td>
              <td style={{ padding: '14px 12px' }}>
                <PriorityDot priority={c.priority} />
              </td>
              <td style={{ padding: '14px 12px' }}>
                {c.assigned ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: 8,
                        background: `linear-gradient(135deg, ${S.burgundy}22, ${S.burgundy}11)`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 10,
                        fontWeight: 700,
                        color: S.burgundy,
                      }}
                    >
                      {c.assignedInitials}
                    </div>
                    <span style={{ fontSize: 13, color: S.textSecondary }}>{c.assigned}</span>
                  </div>
                ) : (
                  <span style={{ fontSize: 12, color: '#d97706', fontWeight: 500, fontStyle: 'italic' }}>{t('screens.claimsScreen.unassigned')}</span>
                )}
              </td>
              <td style={{ padding: '14px 12px', fontSize: 12, color: S.textMuted }}>{c.updated}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {filtered.length === 0 && (
        <div style={{ textAlign: 'center', padding: '80px 20px' }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: 16,
              background: S.bgCard,
              border: `2px dashed ${S.borderLight}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
            }}
          >
            <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#94a3b8' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
              <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
            </svg>
          </div>
          <div style={{ fontSize: 16, fontWeight: 600, color: S.textPrimary, marginBottom: 6 }}>{t('screens.claimsScreen.emptyTitle')}</div>
          <div style={{ fontSize: 13, color: S.textMuted, marginBottom: 20 }}>
            {canCreateClaim(userRole) ? t('screens.claimsScreen.emptyDescriptionCreate') : t('screens.claimsScreen.emptyDescription')}
          </div>
          {canCreateClaim(userRole) && (
            <button
              onClick={() => history.push('/claims/new')}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                padding: '10px 20px',
                background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
                color: '#fff',
                border: 'none',
                borderRadius: 10,
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#fff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                <line x1='12' y1='5' x2='12' y2='19' />
                <line x1='5' y1='12' x2='19' y2='12' />
              </svg>
              {t('screens.claimsScreen.newClaim')}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Table;
